import { render, staticRenderFns } from "./SettingsCoursesDashboardModal.vue?vue&type=template&id=f753713a&scoped=true&lang=pug&"
import script from "./SettingsCoursesDashboardModal.vue?vue&type=script&lang=ts&"
export * from "./SettingsCoursesDashboardModal.vue?vue&type=script&lang=ts&"
import style0 from "./SettingsCoursesDashboardModal.vue?vue&type=style&index=0&id=f753713a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f753713a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSwitch } from 'vuetify/lib/components/VSwitch';
installComponents(component, {VCard,VIcon,VSwitch})
